"use strict";

var _FIELD_INFO;

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it =
    (typeof Symbol !== "undefined" && o[Symbol.iterator]) || o["@@iterator"];
  if (!it) {
    if (
      Array.isArray(o) ||
      (it = _unsupportedIterableToArray(o)) ||
      (allowArrayLike && o && typeof o.length === "number")
    ) {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return { done: true };
          return { done: false, value: o[i++] };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError(
      "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
    );
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var VAL_L = "l";
var VAL_W = "w";
var VAL_LW = "lw";
var VAL_Q = "?";
var VAL_HASH = "#";
var VAL_STAR = "*";
var VAL_DASH = "-";
var VAL_SLASH = "/";
var PREDEFINED_EXPRS = {
  "@yearly": "0 0 1 1 ?",
  "@monthly": "0 0 1 * ?",
  "@weekly": "0 0 ? * 0",
  "@daily": "0 0 * * ?",
  "@hourly": "0 * * * ?"
};
var SECOND = "second";
var MINUTE = "minute";
var HOUR = "hour";
var DAY_OF_MONTH = "day_of_month";
var MONTH = "month";
var DAY_OF_WEEK = "day_of_week";
var YEAR = "year";
var FIELDS = [SECOND, MINUTE, HOUR, DAY_OF_MONTH, MONTH, DAY_OF_WEEK, YEAR];
var FIELD_INFO =
  ((_FIELD_INFO = {}),
  _defineProperty(_FIELD_INFO, SECOND, {
    min: 0,
    max: 59
  }),
  _defineProperty(_FIELD_INFO, MINUTE, {
    min: 0,
    max: 59
  }),
  _defineProperty(_FIELD_INFO, HOUR, {
    min: 0,
    max: 23
  }),
  _defineProperty(_FIELD_INFO, DAY_OF_MONTH, {
    min: 1,
    max: 31
  }),
  _defineProperty(_FIELD_INFO, MONTH, {
    min: 1,
    max: 12,
    alias: {
      jan: 1,
      feb: 2,
      mar: 3,
      apr: 4,
      may: 5,
      jun: 6,
      jul: 7,
      aug: 8,
      sep: 9,
      oct: 10,
      nov: 11,
      dec: 12
    }
  }),
  _defineProperty(_FIELD_INFO, DAY_OF_WEEK, {
    min: 0,
    max: 7,
    alias: {
      7: 0,
      sun: 0,
      mon: 1,
      tue: 2,
      wed: 3,
      thu: 4,
      fri: 5,
      sat: 6
    }
  }),
  _defineProperty(_FIELD_INFO, YEAR, {
    min: 1970,
    max: 3000
  }),
  _FIELD_INFO);

function isTrue(val) {
  return val && val.toString() === "true";
}

function dedupe(inArray) {
  var keySupplier =
    arguments.length > 1 && arguments[1] !== undefined
      ? arguments[1]
      : function (it) {
          return it;
        };
  var seen = new Set();
  var deduped = [];
  inArray.forEach(function (x) {
    var keyValue = keySupplier(x);

    if (!seen.has(keyValue)) {
      seen.add(keyValue);
      deduped.push(x);
    }
  });
  return deduped;
}

function splitAndCleanup(input, sep) {
  return dedupe(
    input
      .split(sep)
      .map(function (part) {
        return part.trim();
      })
      .filter(function (part) {
        return part;
      })
  );
}

function invalidExpr(expr, msg) {
  return new Error("Invalid cron expression [".concat(expr, "]. ").concat(msg));
}

function parseField(expr, field, value) {
  value = value.toLowerCase().trim();

  if (value === VAL_STAR) {
    return {
      all: true
    };
  }

  if (value === VAL_Q) {
    return parseQ(expr, field, value);
  }

  var parts = splitAndCleanup(value, ",");
  var parsed = {};

  var _iterator = _createForOfIteratorHelper(parts),
    _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var part = _step.value;

      if (!part) {
        continue;
      }

      if (part.indexOf(VAL_SLASH) >= 0) {
        parsed.steps = parsed.steps || [];
        parsed.steps.push(parseStepRange(expr, field, part));
      } else if (part.indexOf(VAL_DASH) >= 0) {
        parsed.ranges = parsed.ranges || [];
        parsed.ranges.push(parseRange(expr, field, part));
      } else if (part.indexOf(VAL_HASH) >= 0) {
        parsed.nthDays = parsed.nthDays || [];
        parsed.nthDays.push(parseNth(expr, field, part));
      } else if (part === VAL_L) {
        parsed.lastDay = parseL(expr, field, part);
      } else if (part === VAL_LW) {
        parsed.lastWeekday = parseLW(expr, field, part);
      } else if (field === DAY_OF_MONTH && part.indexOf(VAL_W) >= 0) {
        parsed.nearestWeekdays = parsed.nearestWeekdays || [];
        parsed.nearestWeekdays.push(parseNearestWeekday(expr, field, part));
      } else if (field === DAY_OF_WEEK && part.endsWith(VAL_L)) {
        parsed.lastDays = parsed.lastDays || [];
        parsed.lastDays.push(parseLastDays(expr, field, part));
      } else {
        parsed.values = parsed.values || [];
        parsed.values.push(parseValue(expr, field, part));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (parsed.values) {
    parsed.values = dedupe(parsed.values);
  }

  return parsed;
}

function parseL(expr, field, value) {
  if (field === DAY_OF_WEEK || field === DAY_OF_MONTH) {
    return true;
  }

  throw invalidExpr(
    expr,
    "Invalid value for ["
      .concat(value, "] for field [")
      .concat(field, "]. It can be used only for [")
      .concat(DAY_OF_MONTH, " or ")
      .concat(DAY_OF_WEEK, "] fields.")
  );
}

function parseQ(expr, field, value) {
  if (field === DAY_OF_WEEK || field === DAY_OF_MONTH) {
    return {
      omit: true
    };
  }

  throw invalidExpr(
    expr,
    "Invalid Value ["
      .concat(value, "] for field [")
      .concat(field, "]. It can be specified only for [")
      .concat(DAY_OF_MONTH, " or ")
      .concat(DAY_OF_WEEK, "] fields.")
  );
}

function parseLW(expr, field, value) {
  if (field === DAY_OF_MONTH) {
    return true;
  }

  throw invalidExpr(
    expr,
    "Invalid value for ["
      .concat(value, "] for field [")
      .concat(field, "]. It can be used only for [")
      .concat(DAY_OF_MONTH, "] fields.")
  );
}

function parseValue(expr, field, value) {
  var num = parseNumber(expr, field, value);
  var info = FIELD_INFO[field];

  if (num < info.min) {
    throw invalidExpr(
      expr,
      "Value ["
        .concat(value, "] out of range for field [")
        .concat(field, "]. It must be greater than or equals to [")
        .concat(info.min, "].")
    );
  }

  if (info.max && num > info.max) {
    throw invalidExpr(
      expr,
      "Value ["
        .concat(value, "] out of range for field [")
        .concat(field, "]. It must be less than or equals to [")
        .concat(info.max, "].")
    );
  }

  return num;
}

function parseStepRange(expr, field, value) {
  var parts = value.split(VAL_SLASH);

  if (parts.length != 2) {
    throw invalidExpr(
      expr,
      "Invalid step range ["
        .concat(value, "] for field [")
        .concat(
          field,
          "]. Expected exactly 2 values separated by a / but got ["
        )
        .concat(parts.length, "] values.")
    );
  }

  var info = FIELD_INFO[field];
  var fromParts =
    parts[0].indexOf(VAL_DASH) >= 0 ? parts[0].split(VAL_DASH) : [parts[0]];
  var from = parseNumber(
    expr,
    field,
    unalias(
      field,
      fromParts[0] === VAL_STAR ? info.min.toString() : fromParts[0]
    )
  );
  var to = parseNumber(
    expr,
    field,
    unalias(field, fromParts.length > 1 ? fromParts[1] : info.max.toString())
  );
  var step = parseNumber(expr, field, unalias(field, parts[1]));

  if (from < info.min) {
    throw invalidExpr(
      expr,
      "Invalid step range ["
        .concat(value, "] for field [")
        .concat(field, "]. From value [")
        .concat(from, "] out of range. It must be greater than or equals to [")
        .concat(info.min, "]")
    );
  }

  if (to > info.max) {
    throw invalidExpr(
      expr,
      "Invalid step range ["
        .concat(value, "] for field [")
        .concat(field, "]. To value [")
        .concat(to, "] out of range. It must be less than or equals to [")
        .concat(info.max, "]")
    );
  }

  if (step > info.max) {
    throw invalidExpr(
      expr,
      "Invalid step range ["
        .concat(value, "] for field [")
        .concat(field, "]. Step value [")
        .concat(value, "] out of range. It must be less than or equals to [")
        .concat(info.max, "]")
    );
  }

  return {
    from: from,
    to: to,
    step: step
  };
}

function parseNth(expr, field, value) {
  if (field !== DAY_OF_WEEK) {
    throw invalidExpr(
      expr,
      "Invalid value ["
        .concat(value, "] for field [")
        .concat(field, "]. Nth day can be used only in [")
        .concat(DAY_OF_WEEK, "] field.")
    );
  }

  var parts = value.split(VAL_HASH);

  if (parts.length !== 2) {
    throw invalidExpr(
      expr,
      "Invalid nth day value ["
        .concat(value, "] for field [")
        .concat(field, "]. It must be in [")
        .concat(DAY_OF_WEEK, "#instance] format.")
    );
  }

  var day_of_week = parseNumber(expr, field, parts[0]);
  var instance = parseNumber(expr, undefined, parts[1]);

  if (instance < 1 || instance > 5) {
    throw invalidExpr(
      expr,
      "Invalid Day of Week instance value ["
        .concat(instance, "] for field [")
        .concat(field, "]. It must be between 1 and 5.")
    );
  }

  return {
    day_of_week: day_of_week,
    instance: instance
  };
}

function parseNearestWeekday(expr, field, value) {
  if (field !== DAY_OF_MONTH) {
    throw invalidExpr(
      expr,
      "Invalid value ["
        .concat(value, "] for field [")
        .concat(field, "]. Nearest weekday can be used only in [")
        .concat(DAY_OF_MONTH, "] field.")
    );
  }

  return parseNumber(expr, field, value.split(VAL_W)[0]);
}

function parseLastDays(expr, field, value) {
  return parseNumber(expr, field, value.split(VAL_L)[0]);
}

function parseRange(expr, field, value) {
  var parts = value.split(VAL_DASH);

  if (parts.length != 2) {
    throw invalidExpr(
      expr,
      "Invalid range ["
        .concat(value, "] for field [")
        .concat(
          field,
          "]. Range should have two values separated by a - but got ["
        )
        .concat(parts.length, "] values.")
    );
  }

  var from = parseNumber(expr, field, unalias(field, parts[0]));
  var to = parseNumber(expr, field, unalias(field, parts[1])); // For day of week, sun will act as 0 or 7 depending on if it is in from or to

  if (field == DAY_OF_WEEK) {
    if (to === 0) {
      to = 7;
    }
  }

  if (from >= to) {
    throw invalidExpr(
      expr,
      "Invalid range ["
        .concat(value, "] for field [")
        .concat(field, "]. From value must be less than to value.")
    );
  }

  var info = FIELD_INFO[field];

  if (from < info.min || to > info.max) {
    throw invalidExpr(
      expr,
      "Invalid range ["
        .concat(value, "] for field [")
        .concat(
          field,
          "]. From or to value is out of allowed min/max values. Allowed values are between ["
        )
        .concat(info.min, "-")
        .concat(info.max, "].")
    );
  }

  return {
    from: from,
    to: to
  };
}

function parseNumber(expr, field, value) {
  var num = parseInt(unalias(field, value), 10);

  if (Number.isNaN(num)) {
    throw invalidExpr(
      expr,
      "Invalid numeric value ["
        .concat(value, "] in field [")
        .concat(field, "].")
    );
  }

  return num;
}

function unalias(field, value) {
  if (!field) {
    return value;
  }

  var info = FIELD_INFO[field];
  var unaliased = (info.alias || {})[value];
  return unaliased === undefined ? value : unaliased.toString();
}

function parseExpr(expr, options) {
  if (!expr) {
    throw new Error("Cron expression cannot be blank");
  }

  var exprInternal = expr;
  var hasSeconds = options.hasSeconds;

  if (PREDEFINED_EXPRS[exprInternal]) {
    exprInternal = PREDEFINED_EXPRS[expr];
    hasSeconds = false;
  }

  var minFields = hasSeconds ? 5 : 4;
  var maxFields = hasSeconds ? 7 : 6;
  var parts = exprInternal
    .split(/\s+/)
    .map(function (part) {
      return part.trim();
    })
    .filter(function (part) {
      return part;
    });

  if (parts.length < minFields || parts.length > maxFields) {
    throw new Error(
      "Invalid cron expression ["
        .concat(expr, "]. Expected [")
        .concat(minFields, " to ")
        .concat(maxFields, "] fields but found [")
        .concat(parts.length, "] fields.")
    );
  } // If seconds is not specified, then defaults to 0th sec

  if (!hasSeconds) {
    parts.unshift("0");
  } // If day of week is not specified, will default to ?

  if (parts.length === 5) {
    parts.push(VAL_Q);
  } // If year is not specified, then default to *

  if (parts.length === 6) {
    parts.push(VAL_STAR);
  }

  var fieldParts = {};

  for (var i = 0; i < FIELDS.length; i++) {
    fieldParts[FIELDS[i]] = parts[i];
  }

  var parsed = {};

  var _iterator2 = _createForOfIteratorHelper(FIELDS),
    _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
      var field = _step2.value;

      if (field === SECOND && !hasSeconds) {
        parsed[field] = {
          omit: true
        };
      } else {
        parsed[field] = parseField(expr, field, fieldParts[field]);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return parsed;
}

function parse(exprs) {
  var options =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!exprs) {
    throw new Error("Cron expression cannot be blank");
  }

  options.hasSeconds = isTrue(options.hasSeconds);
  var resp = {
    pattern: exprs,
    expressions: splitAndCleanup(exprs, "|").map(function (expr) {
      return parseExpr(expr, options);
    })
  };
  return resp;
}